export default function StatsCard({ label, value }) {
  return <div className="glass rounded-app p-4"><p className="text-xs text-tg-hint">{label}</p><strong className="mt-2 block text-2xl">{value}</strong></div>;
}
